module.exports = __webpack_public_path__ + "img/blind-box.a806ee95.png";